import { ComponentProps, FC, Ref } from "react";

import Box from "@mui/material/Box";

import {
  SquareImageEditor,
  type SquareImageEditorHandle,
  // eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
} from "@/features/LiveFormEditor/components/SquareImageEditor/SquareImageEditor";

type SquareEditorOverlayProps = ComponentProps<typeof SquareImageEditor> & {
  editorRef: Ref<SquareImageEditorHandle>;
};

export const SquareEditorOverlay: FC<SquareEditorOverlayProps> = ({ editorRef, ...squareEditorProps }) => {
  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        zIndex: 10,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <SquareImageEditor ref={editorRef} {...squareEditorProps} />
      </Box>
    </Box>
  );
};
